import React, { useState } from 'react';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
export function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <Home data-id="element-0" />;
      case 'about':
        return <About data-id="element-1" />;
      case 'contact':
        return <Contact data-id="element-2" />;
      default:
        return <Home data-id="element-3" />;
    }
  };
  return <Layout currentPage={currentPage} setCurrentPage={setCurrentPage} data-id="element-4">
      {renderPage()}
    </Layout>;
}